export const SUPABASE_FUNCTION_BASE_URL = 'https://chnnrqqgqhwehkqzfjnd.functions.supabase.co';

export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNobm5ycXFncWh3ZWhrcXpmam5kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE2Mzg5MDYsImV4cCI6MjA2NzIxNDkwNn0.oq1NRzaVUcF4xPYfsPReIEEd8r0tr3F7dXlS1QKRQp8';
